// returns true if block is in viewport
const onScreen = ({ viewport, block, requiredPercentOnScreen }) => {
  // check if block is inside visible page
  if (block.page) {
    return block.page.classList.contains('visible');
  }

  // fully visible
  if ((block.bottom <= viewport.bottom) && (block.top >= viewport.top)) {
    return true;
  }
  // block bigger than viewport
  if (block.height > viewport.height) {
    if ((viewport.bottom - block.top) > (viewport.height / 2) &&
        (block.bottom - viewport.top) > (viewport.height / 2)) {
      return true;
    }
  }
  // partially visible
  const partialHeight = block.height * (requiredPercentOnScreen / 100);
  if ((viewport.bottom - partialHeight) >= block.top &&
      (block.bottom - partialHeight) > viewport.top) {
    return true;
  }
  // not visible
  return false;
}

export default onScreen;
